import React from 'react'
import { Helmet } from 'react-helmet'
import Layout from '../../components/web/Layout'
import HeroSlider from '../../components/web/home/HeroSlider'
import DepartmentsShowcase from '../../components/web/home/DepartmentsShowcase'
import TeamAndFAQ from './TeamAndFAQ'
import HistoryAboutSection from './HistoryAboutSection'
import FilmDepartmentsShowcase from '../../components/web/home/FilmDepartmentsShowcase'
import PopupImage from '../../components/web/PopupImage'

function Home() {
  return (
    <Layout>
      {/* <PopupImage/> */}
      <Helmet>
        <title>Dhadak All Film Kamgar Sanghtana | dhadakkamgarfilmunion</title>
      </Helmet>
      <HeroSlider />
      <FilmDepartmentsShowcase />
      {/* <DepartmentsShowcase /> */}
      <HistoryAboutSection />
      <TeamAndFAQ />
    </Layout>
  )
}

export default Home
